import { api, publicGet } from './client';

export interface InviteResponse {
  inviteCode: string;
  shareUrl: string;
}

export interface Collaborator {
  id: string;
  userId: string;
  name: string;
  email: string;
  role: string;
  joinedAt: string;
}

export interface InviteInfo {
  householdName: string;
  ownerName: string;
}

export const collaboratorsApi = {
  /** POST /households/{id}/invite → { inviteCode, shareUrl } */
  invite: (householdId: string) =>
    api.post<InviteResponse>(`/households/${householdId}/invite`),

  /** GET /households/{id}/collaborators */
  list: (householdId: string) =>
    api.get<Collaborator[]>(`/households/${householdId}/collaborators`),

  /** DELETE /households/{id}/collaborators/{collaboratorId} */
  revoke: (householdId: string, collaboratorId: string) =>
    api.delete<void>(`/households/${householdId}/collaborators/${collaboratorId}`),

  /** POST /invite/accept  body: { inviteCode } */
  acceptInvite: (inviteCode: string) =>
    api.post<{ householdId: string }>('/invite/accept', { inviteCode }),

  /** GET /invite/{code} — público, sem auth */
  getInviteInfo: (code: string) =>
    publicGet<InviteInfo>(`/invite/${code}`),
};
